export default [
  {
    key: 'checkbox',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    label: 'アライアンス名',
    key: 'company',
    _style: 'min-width:200px',
  },
  { label: 'メールアドレス', key: 'email', _style: 'min-width:250px' },
  {
    label: 'ユーザ名',
    key: 'account_name',
    _style: 'min-width:120px',
    slot: true,
  },
  { label: '性別', key: 'gender', _style: 'min-width:75px' },
  { label: 'アプリバージョン', key: 'app_version', _style: 'min-width:90px' },
  { label: 'プラットフォーム', key: 'platform', _style: '' },
  { label: 'OSバージョン', key: 'mobile_os', _style: '' },
  { label: 'デバイス', key: 'cellphone_model', _style: 'min-width:120px' },
  { label: '登録日時', key: 'created_at', _style: 'min-width:120px' },
]
